let states = {
    loginType:{}
}

export default states